const groupBy = <T extends unknown>(arr: T[], len: number) => {
  if (!arr || arr.length === 0 || len <= 0) {
    return []
  }
  const result = []
  let i = 0
  let sub: T[] = []
  for (let j = 0; j < arr.length; j++) {
    if (i === len) {
      result.push(sub)
      sub = []
      i = 0
    }
    sub.push(arr[j])
    i++
    if (j === arr.length - 1) {
      result.push(sub)
    }
  }
  return result
}
export default groupBy
